import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { map, Observable, of } from 'rxjs';

import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class NeedPermissionGuard {
  private router = inject(Router);
  private auth = inject(AuthService);
  snackBar = inject(MatSnackBar);

  private readonly redirectUrl = '/';

  canActivate(route: ActivatedRouteSnapshot): Observable<true | UrlTree> {
    const neededPermission = route.data['neededPermission'] as string;

    if (!neededPermission) {
      return of(true);
    }

    return this.auth.userHasSomePermissions(neededPermission.split(',')).pipe(
      map(canAccess => {
        if (canAccess) {
          return true;
        }
        this.snackBar.open('You are not authorized to go there.', 'OK', {
          duration: 3000,
          panelClass: 'error-snack-bar',
        });
        return this.router.parseUrl(this.redirectUrl);
      })
    );
  }
}
